import type {
    ListDataType,
    MarketingMerchantType,
    MarketingCabinetType,
    MarketingCabinetCreateType,
    ResponseWithMessage,
} from "@src/types";
import { privateApi } from "./client";

export async function getMarketingCabinetsApi(
    signal?: AbortSignal,
): Promise<ListDataType<MarketingCabinetType>> {
    const { data } = await privateApi.get<ListDataType<MarketingCabinetType>>(
        "/api/marketing-cabinets/list/by-user",
        {
            signal,
        },
    );
    return data;
}

export async function marketingCabinetRegisterApi(
    payload: MarketingCabinetCreateType,
): Promise<ResponseWithMessage> {
    const { data } = await privateApi.post<ResponseWithMessage>(
        "/api/marketing-cabinets/register",
        payload,
    );
    return data;
}

export async function getMarketingMerchantsApi(
    signal?: AbortSignal,
): Promise<ListDataType<MarketingMerchantType>> {
    const { data } = await privateApi.get<ListDataType<MarketingMerchantType>>(
        "/api/marketing-merchants/list/by-user",
        {
            signal,
        },
    );
    return data;
}

export async function getMarketingMerchantsByCabinetApi(
    marketingCabinetId: string,
    signal?: AbortSignal,
): Promise<ListDataType<MarketingMerchantType>> {
    const { data } = await privateApi.get<ListDataType<MarketingMerchantType>>(
        `/api/marketing-merchants/list/by-cabinet/${marketingCabinetId}`,
        {
            signal,
        },
    );
    return data;
}
